import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import AppLayout from './components/layout/AppLayout';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import AssetsPage from './pages/AssetsPage';
import JobsPage from './pages/JobsPage';
import JobDetailPage from './pages/JobDetailPage';
import WorkflowsPage from './pages/WorkflowsPage';
import TechnicianPage from './pages/TechnicianPage';
import UsersPage from './pages/UsersPage';
import TaxonomyPage from './pages/TaxonomyPage';
import SOPsPage from './pages/SOPsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import ProfilePage from './pages/ProfilePage';
import AuditLogsPage from './pages/AuditLogsPage';
import './index.css';

const PrivateRoute = ({ children, permission, superOnly }) => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', background:'var(--bg)' }}>
      <div className="spinner" style={{ width:36, height:36, borderWidth:3 }} />
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === 'super_admin') return children;
  if (superOnly) return <Navigate to="/" replace />;
  if (permission && !user.permissions?.includes(permission)) return <Navigate to="/" replace />;
  
  return children;
};

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" toastOptions={{
            duration: 3500,
            style: { fontFamily: 'DM Sans, sans-serif', fontSize: 14, fontWeight: 500, borderRadius: 10, boxShadow: '0 8px 24px rgba(0,0,0,0.12)' }
          }} />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/" element={
              <PrivateRoute><AppLayout /></PrivateRoute>
            }>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="assets" element={
                <PrivateRoute permission="assets"><AssetsPage /></PrivateRoute>
              } />
              <Route path="jobs" element={
                <PrivateRoute permission="jobs"><JobsPage /></PrivateRoute>
              } />
              <Route path="jobs/:id" element={
                <PrivateRoute><JobDetailPage /></PrivateRoute>
              } />
              <Route path="workflows" element={
                <PrivateRoute permission="workflows"><WorkflowsPage /></PrivateRoute>
              } />
              <Route path="technician" element={
                <PrivateRoute permission="tech_view"><TechnicianPage /></PrivateRoute>
              } />
              <Route path="sops" element={
                <PrivateRoute permission="sops"><SOPsPage /></PrivateRoute>
              } />
              <Route path="analytics" element={
                <PrivateRoute permission="analytics"><AnalyticsPage /></PrivateRoute>
              } />
              <Route path="users" element={
                <PrivateRoute permission="users"><UsersPage /></PrivateRoute>
              } />
              <Route path="taxonomy" element={
                <PrivateRoute permission="taxonomy"><TaxonomyPage /></PrivateRoute>
              } />
              <Route path="audit-logs" element={
                <PrivateRoute superOnly={true}><AuditLogsPage /></PrivateRoute>
              } />
              <Route path="profile" element={<ProfilePage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
